import axios from 'axios';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarResolucion = ({ refresh }) => {
  const [resoluciones, setResoluciones] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  const deleteResolucion = async (idResolucion) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (!result.isConfirmed) return;

        try {
          const { data } = await axios.delete(`/api/resolucion/${idResolucion}`);

          if (data.ok) {
            await getData();
            Swal.fire({
              icon: 'success',
              title: data.message || 'Resolución eliminada',
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            Swal.fire('Error', 'No se pudo eliminar la resolución.', 'error');
          }
        } catch (error) {
          console.error('Error al eliminar la resolución:', error);
          Swal.fire('Error', 'No se pudo eliminar la resolución.', 'error');
        }
      });
    } catch (error) {
      console.error('Error en confirmación:', error);
    }
  };

  const getData = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await axios.get(`/api/resolucion/listbyenteid/${id}`);

      if (data.ok && Array.isArray(data.resolucionEntes)) {
        const resolucionesProcesadas = data.resolucionEntes.map((resolucion) => ({
          ...resolucion,
          nombreEnteconformador: resolucion.enteObjectId?.nombreEnteconformador || 'Ente no disponible',
          coddaneEnteconformador: resolucion.enteObjectId?.coddaneEnteconformador || 'Dane no disponible',
          nitEnteconformador: resolucion.enteObjectId?.nitEnteconformador || 'Nit no disponible',
          fechaResolucion: resolucion.fechaResolucionEnte
            ? new Date(resolucion.fechaResolucionEnte).toLocaleDateString('es-CO')
            : 'Fecha no disponible',

          funciones: (
            <div className="d-flex gap-2 flex-wrap justify-content-end">
              {/* Editar */}
              <button
                className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() => navigate(`/enteconformador/resoluciones/editar/${resolucion._id}`)}
                title="Editar Resolución"
                type="button"
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              {/* Eliminar */}
              <button
                className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center"
                style={{ width: 34, height: 34 }}
                onClick={() => deleteResolucion(resolucion._id)}
                title="Eliminar Resolución"
                type="button"
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          ),
        }));

        // Más reciente arriba
        setResoluciones(resolucionesProcesadas.reverse());
      } else {
        setResoluciones([]);
      }
    } catch (error) {
      console.error('Error al cargar las resoluciones:', error);
      setResoluciones([]);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [id, navigate]);

  useEffect(() => {
    if (id) getData();
  }, [getData, refresh, id]);

  const columns = useMemo(
    () => [
      { Header: 'Código', accessor: 'codResolucionEnte' },
      { Header: 'Fecha', accessor: 'fechaResolucion' },
      { Header: 'Tipo', accessor: 'tipoResolucionEnte' },
      { Header: 'Nit Ente', accessor: 'nitEnteconformador' },
      { Header: 'Dane Ente', accessor: 'coddaneEnteconformador' },
      { Header: 'Ente Conformador', accessor: 'nombreEnteconformador' },
      { accessor: 'funciones' },
    ],
    []
  );

  return (
    <div className="bg-body-tertiary py-4">
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">Listado de resoluciones</h5>
                <small className="text-secondary">
                  Gestión de resoluciones asociadas al ente conformador.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-outline-dark"
                  type="button"
                  onClick={() => navigate(-1)}
                  title="Volver">
                  <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                  Volver
                </button>

                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => getData()}
                  title="Actualizar"
                  disabled={loading}
                >
                  <i className={`fa-solid ${loading ? 'fa-spinner fa-spin' : 'fa-rotate'} me-2`}></i>
                  Actualizar
                </button>

                                <button
                  className="btn btn-dark"
                  type="button"
                 onClick={() =>
                  navigate(`/enteconformador/resoluciones/registrar/${id}`)
                }
                  disabled={loading}
                  title="Registrar Acta"
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Nuevo
                </button>


              </div>
            </div>
          </div>

          {/* Body */}
          <div className="p-3 p-md-4">
            {loading ? (
              <div className="text-center text-secondary py-5">
                <div className="spinner-border" role="status" aria-hidden="true"></div>
                <div className="mt-3">Cargando resoluciones…</div>
              </div>
            ) : Array.isArray(resoluciones) && resoluciones.length > 0 ? (
              <div className="overflow-hidden">
                <DataTable columns={columns} data={resoluciones} />
              </div>
            ) : (
              <div className="text-center text-secondary py-5">
                <div className="display-6 mb-2">🐾</div>
                <div className="fw-semibold">No hay resoluciones registradas</div>
                <div className="small">No se encontraron resoluciones para este ente.</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListarResolucion;
